import { FormGroup } from '@angular/forms';

export function MismatchValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (control.pristine || matchingControl.pristine) {
            return;
        }

        if (matchingControl.errors && !matchingControl.errors['mismatch']) {
            return;
        }

        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mismatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}